import { ReactNode } from "react";

const DataLabel = ({ label, value }: { label: string; value: ReactNode }) => {
    return (
        <div className="h-fit">
            <label className="font-[400] text-[13px]">
                <span>{label}:</span>
                <div className="text-tertiary font-[600] text-[16px] input w-full border border-[#DCDCDC] bg-[#F3F3F3]">
                    {value}
                </div>
            </label>
        </div>
    )
}

export default DataLabel